import { store } from '@atredux/store'
import { getSelectedTool } from '@src/redux/selectors/toolSelector'

export async function getCurrentToolListener () {
    console.log('ATBase: Received request for current tool.')
    const currentTool = getSelectedTool(store.getState())
    return Promise.resolve(currentTool.toolName)
}
